import React, { memo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { InvoiceManager } from '../../../../../../components/requestComponents';
import { ReactComponent as PaymentFilterIcon } from '../../../../../../resource/PaymentInCashIcon.svg';
import { OrderIcon, RubleIcon } from '../../../../../../resource/icons';
import {
  hasFilterValue,
  selectPaidOrdersActiveCount,
} from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { requestFilterSectionIds } from '../../../model/sectionExpansion';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FlagControl from '../../primitives/FlagControl';
import FilterSection from '../../primitives/FilterSection';
import { multiSelectTagProps } from '../../primitives/selectTagProps';
import styles from './PaidOrdersFilterSection.module.scss';

const { SelectPaymentState } = InvoiceManager;

const selectPaidOrdersFilterState = (state) => {
  const filter = state.filterStore;

  return {
    valuePaymentState: filter.valuePaymentState,
    chargeable: filter.chargeable,
    isOrder: filter.isOrder,
  };
};

const PaidOrdersFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const filter = useSelector(selectPaidOrdersFilterState, shallowEqual);
  const activeCount = useSelector(selectPaidOrdersActiveCount);
  const { changeFilter } = useFilterChange();

  return (
    <FilterSection
      sectionId={requestFilterSectionIds.paidOrders}
      heading="Платные заказы и услуги"
      description="Статус оплаты, платные заказы и заявки"
      icon={<PaymentFilterIcon />}
      activeCount={activeCount}
    >
      <div className={styles.grid}>
        <FilterField
          label="Статус оплаты"
          active={hasFilterValue(filter.valuePaymentState)}
          className={styles.fullWidth}
        >
          <SelectPaymentState
            {...multiSelectTagProps}
            style={{ width: '100%' }}
            value={filter.valuePaymentState}
            onChange={(value) => {
              changeFilter(filterCommands.applyPaymentState(value));
            }}
          />
        </FilterField>

        <FlagControl
          active={filter.chargeable}
          icon={<RubleIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyChargeable(value));
          }}
        >
          Платная
        </FlagControl>

        <FlagControl
          active={filter.isOrder}
          icon={<OrderIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyIsOrder(value));
          }}
        >
          Заказ
        </FlagControl>
      </div>
    </FilterSection>
  );
};

export default memo(PaidOrdersFilterSection);
